import { graphql, useStaticQuery} from 'gatsby';
import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import {
  FaLinkedinIn,
  FaTwitter,
  FaGithub,
  FaArtstation,
  FaInstagram,
} from 'react-icons/fa';
import styled from 'styled-components';

const SketchfabIcon = (props) => (
  <svg viewBox="0 0 2000 2000" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" {...props}>
    <path d="m1000 0c-552.32 0-1000 447.72-1000 1000s447.68 1000 1000 1000 1000-447.72 1000-1000-447.6-1000-1000-1000zm-86.88 1595.07-431.12-248.86v-502l431.12 232.79zm76.8-636.19-510.08-270.38 510.08-294.5 510.16 294.5zm510.48 388.29-429.52 248v-516.17l429.52-232z" />
  </svg>
);

const FooterStyles = styled.footer`
  width: 100%;
  margin: 0 auto;
  margin-top: 3rem;
  padding-bottom: 2rem;

  .user-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    gap: 3rem;
  }

  .social-link {
    font-size: 2em;
    color: var(--body);
  }

  .social-link img{
    height: 1em;
    color: var(--body);
    box-shadow: none;
  }

  .footer-quote {
    margin: 20px auto;
    padding: 20px 0px;
    display: block;
    width: 90%;
    text-wrap: balance;
  }

  .notice-container {
    margin: 20px auto;
    padding-bottom: 20px;
    display: block;
  }

  .social-link:hover {
    filter: drop-shadow(0 0 5px var(--hover));
  }

  .twitter:hover {
    color: #1da1f2;
  }
  .instagram:hover {
    color: #e1306c;
  }
  .artstation:hover {
    color: #13aff0;
  }
  .linkedin:hover {
    color: #0a66c2;
  }
  .github:hover {
    color: #7b7b7b;
  }
  .sketchfab:hover {
    color: #1faad8;
  }
`;

export default function Footer() {
  const { quotes } = useStaticQuery(graphql`
    query {
      quotes: allSanityQuote {
        nodes {
          quote
          author
        }
      }
    }
  `);
  const { theme } = useContext(ThemeContext);
  const random = Math.floor(Math.random() * quotes.nodes.length);
  const randomQuote = quotes.nodes[random].quote;

  var copyrightText = `© Nick Brown ${new Date().getFullYear()}`;
  return (
    <FooterStyles>
      <div className="user-links">
        {/* <OutboundLink
          aria-label="Twitter"
          className="social-link twitter"
          href="https://www.twitter.com/prismexpress"
        >
          <FaTwitter style={{ stroke: 'url(#blue-gradient)' }} />
        </OutboundLink> */}
        <OutboundLink
          aria-label="Instagram"
          className="social-link instagram"
          href="https://www.instagram.com/r5d4/"
        >
          <FaInstagram />
        </OutboundLink>
        <OutboundLink
          aria-label="LinkedIn"
          className="social-link linkedin"
          href="https://www.linkedin.com/in/nick-brown-772058a3/"
        >
          <FaLinkedinIn />
        </OutboundLink>
        {/* <OutboundLink
          aria-label="Github"
          className="social-link github"
          href="https://github.com/nickmbrown"
        >
          <FaGithub />
        </OutboundLink> */}
        <OutboundLink
          aria-label="ArtStation"
          className="social-link artstation"
          href="https://www.artstation.com/nickmbrown"
        >
          <FaArtstation />
        </OutboundLink>
        <OutboundLink
          aria-label="Sketchfab"
          className="social-link sketchfab"
          href="https://www.sketchfab.com/prismexpress"
        >
          <SketchfabIcon />
        </OutboundLink>
      </div>
      <span
        className="footer-quote"
        id="footer-quote"
      >
        <span>"{randomQuote}"</span><br/>
        <span>- {quotes.nodes[random].author}</span>
      </span>

      <span className="notice-container center">
        { theme === 'dark' ? 
          '// ' + copyrightText : 
          '✦ ' + copyrightText + ' Anno Domini ✦'
        }
      </span>
    </FooterStyles>
  );
}
